import type { GameData } from "@/interfaces";

export const getTextSize = (gameData: GameData) => {
  switch (gameData.text_safe_size) {
    case "small":
      return "text-[9px]";
    case "big":
      return "text-[13px]";
    default:
      return "text-[11px]";
  }
};
